<template>
    <div class="row">
        <div class="col-12">
            <div class="row">
                <div class="col-sm-12 col-md-7">
                    <h3>Buy Group Dates</h3>
                </div>
                <div class="col-sm-12 col-md-3 text-right">
                    <div class="form-group">
                        <div class="input-group search-field">
                            <input
                                class="form-control"
                                type="text"
                                placeholder="Search Buy Group Dates"
                                v-model="searchTerm"
                                autocomplete="off"
                            />
                            <div class="input-group-prepend">
                                <span class="input-group-text"
                                    ><i class="fas fa-search"></i
                                ></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-2 text-right">
                    <router-link
                        class="btn add-button btn btn-action w-100"
                        to="/create-buy-group-date"
                    >
                        CREATE BUY GROUP DATE
                    </router-link>
                </div>
            </div>
            <table
                class="table table-responsive table-striped border-bottom mt-2"
            >
                <thead class="thead-light">
                    <tr>
                        <th>Pricelist</th>
                        <th>Category Name</th>
                        <th>Name</th>
                        <th style="width: 8em">Accessories Minimum Qty</th>
                        <th style="width: 8em">Order Suppressor Minimum Qty</th>
                        <th style="width: 8em">Minimum Qty Per Item</th>
                        <th style="width: 8em">Require All Items</th>
                        <th style="width: 8em">Premier Dealer</th>
                        <th style="width: 8em">Buy Group Dealer</th>
                        <th style="width: 8em">Order Minimum</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th style="width: 8em"></th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="item in paginatedAllBuyGroupDates" :key="item.id">
                        <tr>
                            <td>{{ item.pricelist?.pricelist_name }}</td>
                            <td>{{ item.category_name }}</td>
                            <td>{{ item.name }}</td>
                            <td>{{ item.accessories_minimum_quantity }}</td>
                            <td>{{ item.order_suppressor_minimum_quantity }}</td>
                            <td>{{ item.minimum_quantity_per_item }}</td>
                            <td>{{ item.require_all_items ? "Yes" : "No" }}</td>
                            <td>{{ item.is_premier_dealer ? "Yes" : "No" }}</td>
                            <td>{{ item.is_buy_group_dealer ? "Yes" : "No" }}</td>
                            <td>{{ item.order_minimum }}</td>
                            <td>
                                {{
                                    $filters.dateFormat(
                                        item.start_date
                                    )
                                }}
                            </td>
                            <td>
                                {{
                                    $filters.dateFormat(
                                        item.end_date
                                    )
                                }}
                            </td>
                            <td style="width: 20px" class="text-right">
                                <!-- <span
                                    class="px-1 view-action"
                                    @click="viewBuyGroupDate(item)"
                                    ><i class="fa fa-eye" aria-hidden="true"></i>
                                    VIEW<br
                                /></span> -->
                                <span
                                    class="px-1 view-action"
                                    @click="editBuyGroupDate(item)"
                                    ><i class="fa fa-pencil" aria-hidden="true"></i>
                                    EDIT<br
                                /></span>
                                <span
                                    class="px-1 view-action"
                                    @click="confirmModal(item)"
                                    ><i class="fa fa-trash" aria-hidden="true"></i>
                                    DELETE</span
                                >
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>

            <!-- Pagination -->
            <table-pagination
                v-model="paginatedAllBuyGroupDates"
                :all-rows="searchAllBuyGroupDatesbyTerm"
                :perPage="perPage"
                @updateRow="updateRow"
            >
            </table-pagination>
        </div>

        <!-- Confirmation modal -->
        <b-modal v-model="modalShowConfirm" hide-footer>
            <Confirmation
                v-if="modalShowConfirm"
                :title="'Are you sure you want to delete this buy group date?'"
                @custom-func="deleteQuoteById"
                @close-modal="closeModalConfirm"
            />
        </b-modal>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";

import TablePagination from "@/components/TablePagination.vue";
import Confirmation from "@/components/Confirmation.vue";
import { isSuperAdmin } from "@/helpers";
import { useRouter } from "vue-router";

export default {
    props: [],
    emits: [],
    components: {
        TablePagination,
        Confirmation
    },
    setup() {
        const store = useStore();
        const router = useRouter();

        let user = computed(function () {
            return store.state.user;
        });
        let allBuyGroupDates = computed(function () {
            return store.getters["buyGroupDate/allBuyGroupDates"];
        });

        function setBuyGroupDateInfo(item) {
            store.commit("buyGroupDate/setBuyGroupDateInfo", item);
        }

        onMounted(() => {
          if (!isSuperAdmin(user)) {
            router.push({ name: "dashboard" });
          }
        });

        return {
            store,
            user,
            allBuyGroupDates,
            setBuyGroupDateInfo,
        };
    },
    data() {
        return {
            paginatedAllBuyGroupDates: [],
            perPage: 100,
            isLoading: false,
            searchTerm: "",
            modalShowConfirm: false,
            reqBuyGroupDate: {
                id: null,
            },
        };
    },
    computed: {
        searchAllBuyGroupDatesbyTerm() {
            if (this.searchTerm === "") {
                return this.allBuyGroupDates;
            }

            return this.allBuyGroupDates.filter((item) => {
                if (
                    (item.name !== null &&
                        item.name
                            .toLowerCase()
                            .includes(this.searchTerm.toLowerCase())) ||
                    (item.category_name !== null &&
                        item.category_name
                            .toLowerCase()
                            .includes(this.searchTerm.toLowerCase())) ||
                    (item.pricelist?.pricelist_name !== null &&
                        item.pricelist?.pricelist_name
                            .toLowerCase()
                            .includes(this.searchTerm.toLowerCase()))
                ) {
                    return item;
                }
            });
        },
    },
    mounted() {
      this.store.dispatch("buyGroupDate/getAllBuyGroupDates");
    },
    methods: {
        updateRow(val) {
            this.paginatedAllBuyGroupDates = val;
        },
        viewBuyGroupDate(item) {
            this.setBuyGroupDateInfo(item);
            this.$router.push({ 
                name: "speqBuyGroupDateInfo", 
                params: { id: item.id }
            });
        },
        editBuyGroupDate(item) {
            this.$router.push({
                name: "speqBuyGroupDateEdit",
                params: { id: item.id },
            });
        },
        confirmModal(item) {
            this.reqBuyGroupDate = {
                id: item.id,
            };
            this.modalShowConfirm = !this.modalShowConfirm;
        },
        deleteQuoteById() {
            this.store.dispatch("buyGroupDate/deleteBuyGroupDate", this.reqBuyGroupDate).then((resp) => {
                window.emitter.emit("alertSuccess", {
                    message: "Buy Group Date deleted successfully!",
                });
            });
        },
        closeModalConfirm() {
            this.modalShowConfirm = !this.modalShowConfirm;
        },
        
    },
};
</script>
